export const contentData = {
	displayModuleIds: ['exhibition:296:1773369939209', 'exhibition:20052:1773041894611']
};
